/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: window.AZURE_AD_APPLICATION_ID,
    authority: `https://login.microsoftonline.com/${window.AZURE_AD_SUBMITTABLE_TENANT_ID}`,
    redirectUri: window.AZURE_AD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

export const scope = 'admin-frontend'

export const submittableInternalAdminApiRequest = {
  scopes: [`${window.INTERNAL_API_APPLICATION_URI}/${scope}`],
}

export const submittableFundsDistritubtionApiRequest = {
  scopes: [`${window.FUNDS_DISTRITUBTION_API_APPLICATION_URI}/${scope}`],
}

export const submittableCSRApiRequest = {
  scopes: [`${window.CSR_API_APPLICATION_URI}/${scope}`],
}

export const submittableAblePortalApiRequest = {
  scopes: [`${window.ABLE_PORTAL_API_APPLICATION_URI}/${scope}`],
}

export const submittableAccountSystemApiRequest = {
  scopes: [`${window.ACCOUNT_SYSTEM_API_APPLICATION_URI}/${scope}`],
}

export const submittableOrganizationsApiRequest = {
  scopes: [`${window.ORGANIZATIONS_API_APPLICATION_URI}/${scope}`],
}

export const submittableAuthorizationManagementApiRequest = {
  scopes: [`${window.AUTHORIZATION_MANAGEMENT_API_APPLICATION_URI}/${scope}`],
}
